/*
 * @Description: file content
 * @Author: liuzhezhe
 * @Date: 2022-12-20 16:50:46
 * @LastEditors: liuzhezhe
 * @LastEditTime: 2023-07-06 11:24:41
 */
export const randomString = (length) => {
  const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let result = ''
  for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)]
  return result
}

/**
 * 判断是否是手机浏览器
 * @returns
 */
export function isMobileAgent() {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
    return true
  } else {
    return false
  }
}

/**
 * 判断是否是从微信公众号进入官网
 * @returns
 */
export function is_weixn() {
  var ua = navigator.userAgent.toLowerCase()
  if (/MicroMessenger/i.test(ua)) {
    return true
  } else {
    return false
  }
}
